export default __webpack_public_path__ + "static/media/interview.3746efa1.svg";